<template>
  <div class="box">
    <sidebar />
    <div class="homeBox">
      <div class="head">
        <img class="logo" @click="go" src="../assets/images/logo.png" alt="">
      </div>
      <div class="title">
        <div class="top">
          <img class="titImg wow animated bounceInLeft" src="../assets/images/2021.png" alt="">
          <div class="subtit wow animated fadeInUp">
            <p>PostgreSQLChina Conference</p>
            <p>主办：PostgreSQL中文社区</p>
          </div>
        </div>
        <div class="titTxtImg wow animated fadeInDown">
          <img class="img" src="../assets/images/titTxtImg.png" alt="">
        </div>
        <div class="subBg wow animated bounceInRight">开源论道 ×数据驱动 × 共建数字化未来</div>
        <div class="dateBox wow animated fadeInDown">
          <p>2022 01.07-01.09</p>
          <p>武 汉 • 光谷</p>
        </div>
      </div>
    </div>
    <div class="block dhjj" id="dhjj">
      <div class="itemTitBox wow animated bounceInRight">
        <p class="big">大会简介</p>
        <p class="small">CONFERENCE PROFILE</p>
      </div>
      <div class="dhxq wow animated bounceInLeft">
        <div class="dhxqItem wow animated fadeInUp" v-for="(item, index) in dataJson.conference_synopsis" :key="index">
          <div class="triangle_icon">
            <img src="../assets/images/triangle_icon.png" alt="">
          </div>
          <div class="dhxqTxt">{{item}}</div>
        </div>
      </div>
      <img class="bgImg" src="../assets/images/1614x746.png" />
    </div>
    <!-- 往期嘉宾 -->
    <wqjb></wqjb>
    <dhyc />
    <zbfjj />
    <zzs />
    <hzdw />
    <lxwm />
    <gzwm />
    <wjhg />
    <div class="footer">
        <img @click="go" src="../../static/images/footer.png" alt="">
    </div>
  </div>
</template>
<script>
import {WOW} from 'wowjs'
import 'wowjs/css/libs/animate.css'
import dataJson from '../assets/index.json'
import wqjb from '../components/wqjb.vue'
import zbfjj from '../components/zbfjj.vue'
import dhyc from '../components/dhyc.vue'
import zzs from '../components/zzs.vue'
import hzdw from '../components/hzdw.vue'
import sidebar from '../components/sidebar.vue'
import lxwm from '../components/lxwm.vue'
import gzwm from '../components/gzwm.vue'
import wjhg from '../components/wjhg.vue'

export default {
    components: {
        wqjb,
        zbfjj,
        dhyc,
        zzs,
        hzdw,
        sidebar,
        gzwm,
        lxwm,
        wjhg
    },
  data() {
    return {
      dataJson
    }
  },
    mounted() {
    var wow = new WOW();
    wow.init()
  },
  methods:{
      go() {
          window.open('https://postgres.fun/')
      }
  }
}
</script>
<style lang="less">
@import url('./index.less');
</style>


// WEBPACK FOOTER //
// src/views/index.vue